<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>アカウント申請内容変更</h1>
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.admin.account.error." />
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="12" class="text-right">
        <span class="red--text">※</span>は必須項目です
      </v-col>
    </v-row>

    <!-- ID -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.mailAddress")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ form.mailAddress }}</mp-input-box>
      </v-col>
    </v-row>

    <!-- 氏名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.name")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ form.name }}</mp-input-box>
      </v-col>
    </v-row>

    <!-- 所属 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.group")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-row v-for="(item, index) in getGroupList"
          :key="item.groupLargeId"
        >

          <v-col class="pa-1 pl-3">
            <v-radio-group v-model="form.groupLargeId" class="mt-0">
                <v-radio
                :label="item.groupLargeName.ja"
                :value="item.groupLargeId"
                :id="`groupLargeId-${item.groupLargeId}`"
                hide-details
                dense
                @change="changeGroupLarge(item.groupLargeId, item.companyInsNoFlg)"
                />
              </v-radio-group>
            </v-col>
          <v-col class="py-1 pr-3">
              <v-select
              v-model="form.groupSmallId"
              :items="view.groupList[index].groupSmallList"
              label="選択してください"
              :item-text="getGroupSmallName"
              item-value="groupSmallId"
              :id="`groupSmallId-${item.groupLargeId}`"
              hide-details
              solo
              dense
              :disabled="form.groupLargeId !== item.groupLargeId"
              @change="(groupSmallId) => changeGroupSmall(groupSmallId, item.companyInsNoFlg)"
              ></v-select>
            </v-col>

          </v-row>
      </v-col>
    </v-row>

    <!-- 会社 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{view.companyLabel.ja}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-autocomplete
            v-model="form.companyId"
            :items="view.companyList"
            :label="$t('message.admin.account.ph.companyId')"
            item-text="companyName"
            item-value="companyId"
            :disabled="view.companyList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="companyId"
            hide-details
            solo
            dense
            @change="changeCompany"
          ></v-autocomplete>
          <v-text-field
            v-if="form.companyId === constantValue.otherCompanyId"
            v-model="form.companyName"
            v-bind:placeholder="$t('message.admin.account.ph.companyName').replace('##COMPANY_LABEL##', view.companyLabel.ja)"
            id="companyName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="form.companyId === constantValue.otherCompanyId"
            v-model="form.companyNameKana"
            v-bind:placeholder="$t('message.admin.account.ph.companyNameKana').replace('##COMPANY_LABEL##', view.companyLabel.ja)"
            id="companyNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
      </v-col>
    </v-row>

    <!-- 支社・支局 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{view.branchLabel.ja}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1' && view.branchList.length > 1">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-autocomplete
            v-model="form.branchId"
            :items="view.branchList"
            :label="$t('message.admin.account.ph.branch').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            item-text="branchName"
            item-value="branchId"
            :disabled="view.branchList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="branchId"
            hide-details
            solo
            dense
            @change="changeBranch"
          ></v-autocomplete>
          <v-text-field
            v-if="form.branchId === constantValue.otherBranchId"
            v-model="form.branchName"
            v-bind:placeholder="$t('message.admin.account.ph.branchName').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            id="branchName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="form.branchId === constantValue.otherBranchId"
            v-model="form.branchNameKana"
            v-bind:placeholder="$t('message.admin.account.ph.branchNameKana').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            id="branchNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <div class="mt-2 a-right" v-if="view.branchList.length > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">
            <mp-button min @click="clearBranch">クリア</mp-button>
          </div>
      </v-col>
    </v-row>

    <!-- 郵便番号 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.postNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.postNo"
          hide-details
          v-bind:placeholder="$t('message.admin.account.ph.postNo')"
          id="postNo"
          solo
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 都道府県 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.prefCd")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-select
            v-model="form.prefCd"
            :items="$store.getters.prefCodeList"
            :item-text="getPrefName"
            item-value="kbnCd"
            :label="$t('message.admin.account.ph.prefCd')"
            id="prefCd"
            hide-details
            dense
            solo
          ></v-select>
      </v-col>
    </v-row>

    <!-- 市区町村 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.addr1")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr1"
          v-bind:placeholder="$t('message.admin.account.ph.addr1')"
          id="addr1"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 番地 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.addr2")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr2"
          v-bind:placeholder="$t('message.admin.account.ph.addr2')"
          id="addr2"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- ビル名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.addr3")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr3"
          v-bind:placeholder="$t('message.admin.account.ph.addr3')"
          id="addr3"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 部署 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.busho")}}<span class="red--text" v-if="form.groupLargeId > 0 && view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.busho"
          v-bind:placeholder="$t('message.admin.account.ph.busho')"
          id="busho"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 電話番号 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.telNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.telNo"
          v-bind:placeholder="$t('message.admin.account.ph.telNo')"
          id="telNo"
          hide-details
          dense
          solo
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.remarks")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-textarea
          v-model="form.remarks"
          v-bind:placeholder="$t('message.admin.account.ph.remarks')"
          id="remarks"
          hide-details
          dense
          solo
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 利用希望サービス -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.account.label.services")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox v-for="(item) in view.serviceList"
          :key="item.serviceId"
          v-model="form.services"
          :label="item.serviceName.ja"
          :value="item.serviceId"
          :id="`serviceId-${item.serviceId}`"
          :disabled="!(item.groupLargeIdList.includes(form.groupLargeId) && item.groupSmallIdList.includes(form.groupSmallId))"
          hide-details
          dense
          class="my-2 py-0"
        >
        </v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goBack">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goModify">変更を保存する</mp-button>
        <mp-dialog modify :show="dialog.modifyComplete" @clickOk="goBack"/>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminAccountEntry, Common } from '@/api'
import constantValue from '@/constantValue'
import MpError from '@/components/item/MpError'
import StringUtils from '@/utils/StringUtil'

export default {
  name: 'AdminAccountEntryChange',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog
  },
  data: () => ({
    constantValue: constantValue,
    accountEntryId: null,
    view: {
      companyDefaultLabel: {
        ja: ''
      },
      branchDefaultLabel: {
        ja: ''
      },
      companyLabel: {
        ja: ''
      },
      branchLabel: {
        ja: ''
      },
      groupList: [],
      companyList: [],
      branchList: [],
      serviceList: [],
      errors: [],
      currentCompanyId: '',
      currentCompanyName: '',
      currentCompanyNameKana: '',
      currentBranchId: '',
      currentBranchName: '',
      currentBranchNameKana: '',
      currentServices: []
    },
    form: {
      mailAddress: '',
      name: '',
      groupLargeId: '',
      companyInsNoFlg: '',
      groupSmallId: '',
      companyId: '',
      companyName: '',
      companyNameKana: '',
      branchId: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: []
    },
    dialog: {
      modifyComplete: false
    },
    errMessageReplaceList: []
  }),
  computed: {
    getGroupList () {
      return this.view.groupList
    }
  },
  methods: {
    initCompanyList () {
      this.view.companyList = []
      this.form.companyId = null
      this.form.companyName = ''
      this.form.companyNameKana = ''
    },
    initBranchList () {
      // 一覧および入力・選択情報を初期化
      this.view.branchList = []
      this.form.branchId = null
      this.form.branchName = ''
      this.form.branchNameKana = ''
    },
    initServiceList () {
      this.form.services = []
    },
    initCompanyAndBranchLabel () {
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
    },
    changeGroupLarge (groupLargeId, companyInsNoFlg) {
      // サービス、会社および支社・支局を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.initCompanyAndBranchLabel()

      this.form.companyInsNoFlg = companyInsNoFlg
      this.form.groupSmallId = null
    },
    changeGroupSmall (groupSmallId, companyInsNoFlg) {
      // サービス、会社および支社・支局を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.setCompanyAndBranchLabel(groupSmallId)

      // 現在のサービスが含まれていればセット
      this.setCurrentServices(this.form.groupLargeId, groupSmallId)

      // 会社情報を設定
      if (companyInsNoFlg === '0') {
        this.getCompanyList(groupSmallId).then(() => {
          // 現在の会社が含まれていればセット
          this.setCurrentCompany()
        })
      }
    },
    setCompanyAndBranchLabel (groupSmallId) {
      const groupSmall = this.view.groupList
        .flatMap(groupLarge => groupLarge.groupSmallList)
        .find(groupSmall => groupSmall.groupSmallId === Number(groupSmallId))

      if (groupSmall === undefined) {
        this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
        this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
      } else {
        this.view.companyLabel.ja = StringUtils.isEmpty(groupSmall.companyLabel.ja) ? this.view.companyDefaultLabel.ja : groupSmall.companyLabel.ja
        this.view.branchLabel.ja = StringUtils.isEmpty(groupSmall.branchLabel.ja) ? this.view.branchDefaultLabel.ja : groupSmall.branchLabel.ja
      }
    },
    getGroupSmallName (item) {
      // 日本語のみ
      return item.groupSmallName.ja
    },
    getPrefName (item) {
      // 日本語のみ
      return item.kbnVal.ja
    },
    setCurrentServices (groupLargeId, groupSmallId) {
      for (const item of this.view.serviceList) {
        if (item.groupLargeIdList.includes(groupLargeId) && item.groupSmallIdList.includes(groupSmallId)) {
          if (this.view.currentServices.includes(item.serviceId)) {
            this.form.services.push(item.serviceId)
          }
        }
      }
    },
    setCurrentCompany () {
      if (this.view.companyList.length === 0) {
        return
      }
      if (this.view.companyList.find((item) => item.companyId === this.view.currentCompanyId)) {
        this.form.companyId = this.view.currentCompanyId
        this.form.companyName = this.view.currentCompanyName
        this.form.companyNameKana = this.view.currentCompanyNameKana

        this.changeCompany(this.form.companyId)
      }
    },
    async getCompanyList (groupSmallId) {
      // 返却用のリスト準備
      this.view.companyList = [
        ...(await Common.companyList({ groupSmallId: groupSmallId })),
        { companyName: i18n.t('message.admin.account.select.other'), companyId: constantValue.otherCompanyId }]
    },
    changeCompany (companyId) {
      // 指定あれば名称はクリア
      if (companyId !== constantValue.otherCompanyId) {
        this.form.companyName = ''
        this.form.companyNameKana = ''
      }

      // 支社・支局を初期化
      this.initBranchList()

      // 支社・支局の一覧をセット
      this.getBranchList(companyId).then(() => {
        // 現在の支社・支局が含まれていればセット
        this.setCurrentBranch()
      })
    },
    setCurrentBranch () {
      if (this.view.branchList.length === 0) {
        return
      }
      // 違う会社はセットしない
      if (this.form.companyId !== this.view.currentCompanyId) {
        return
      }
      if (this.view.branchList.find((item) => item.branchId === this.view.currentBranchId)) {
        this.form.branchId = this.view.currentBranchId
        this.form.branchName = this.view.currentBranchName
        this.form.branchNameKana = this.view.currentBranchNameKana
      }
    },
    async getBranchList (companyId) {
      // 返却用のリスト準備
      this.view.branchList = [
        ...(await Common.branchList({ companyId: companyId })),
        { branchName: i18n.t('message.admin.account.select.other'), branchId: constantValue.otherBranchId }
      ]
    },
    changeBranch (branchId) {
      // 指定あれば名称はクリア
      if (branchId !== constantValue.otherBranchId) {
        this.form.branchName = ''
        this.form.branchNameKana = ''
      }
    },
    clearBranch () {
      this.form.branchId = null
      this.form.branchName = ''
      this.form.branchNameKana = ''
    },
    goBack () {
      // 戻る
      this.$router.push({ path: '/admin/account/entry/detail/' + this.accountEntryId })
    },
    async goModify () {
      await AdminAccountEntry.update({ accountEntryId: this.accountEntryId, ...this.form })
        .then(() => {
          this.dialog.modifyComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.branch.ja')
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    setErrMessageReplaceList () {
      this.errMessageReplaceList = [
        { param: 'companyId', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyName', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyNameKana', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'branchId', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchName', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchNameKana', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel }
      ]
    }
  },
  created: async function () {
    this.view.errors = []
    // パラメータからアカウント申請IDを取得
    this.accountEntryId = this.$route.params.id

    this.view.constantValue = constantValue
    this.view.groupList = await Common.groupList()
    this.view.serviceList = await Common.serviceList()

    await this.setDefaultLabel()
    this.setErrMessageReplaceList()

    // アカウント情報取得
    const result = await AdminAccountEntry.getEntry({ accountEntryId: this.accountEntryId })
      .catch(error => { this.view.errors = error.messages })
    this.form = { ...this.form, ...result }

    // 現在値保持
    this.view.currentCompanyId = this.form.companyId
    this.view.currentCompanyName = this.form.companyName
    this.view.currentCompanyNameKana = this.form.companyNameKana
    this.view.currentBranchId = this.form.branchId
    this.view.currentBranchName = this.form.branchName
    this.view.currentBranchNameKana = this.form.branchNameKana
    this.view.currentServices = this.form.services

    // 初期表示
    this.changeGroupSmall(this.form.groupSmallId, this.form.companyInsNoFlg)
  }
}
</script>

<style scoped>
.v-messages {
  min-height: 0px !important;
}
.a-right {
  text-align: end;
}
</style>
